import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  fill: "currentColor",
  "data-name": "Ebene 1",
  viewBox: "0 0 26 26"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M15.67 12.95c.04 1.48-1.16 2.71-2.65 2.73s-2.7-1.18-2.7-2.67 1.22-2.71 2.7-2.69c1.43.02 2.62 1.19 2.65 2.63" }, null, -1),
    _createElementVNode("path", { d: "M19.54 9.36c-.07-1.82-1.27-2.88-3.14-2.94-1.11-.04-2.22 0-3.34 0-1.19 0-2.38-.04-3.57.02-1.9.09-3.03 1.22-3.07 3.12-.06 2.3-.06 4.61 0 6.9.06 1.87 1.18 3.05 2.98 3.1 2.38.07 4.75.06 7.13 0 1.76-.06 2.94-1.14 2.99-2.84.09-2.45.1-4.9 0-7.35Zm-6.53 7.75c-2.28 0-4.16-1.9-4.14-4.19.02-2.27 1.85-4.07 4.12-4.07s4.15 1.82 4.14 4.16c-.02 2.25-1.87 4.1-4.11 4.1Zm4.11-7.94a.939.939 0 1 1 0-1.88.939.939 0 1 1 0 1.88" }, null, -1),
    _createElementVNode("path", { d: "M13 .2C5.93.2.2 5.93.2 13S5.93 25.8 13 25.8 25.8 20.06 25.8 13 20.06.2 13 .2m7.9 16.75c-.1 2.28-1.74 3.84-4.02 3.98-1.33.08-2.67.02-4.01.02-1.22 0-2.45.06-3.67 0-2.33-.13-4.02-1.7-4.11-4.02-.11-2.62-.11-5.26 0-7.9.09-2.15 1.57-3.78 3.7-3.9 2.8-.16 5.63-.16 8.44 0 2.07.11 3.57 1.72 3.66 3.82.12 2.66.13 5.34 0 8.01Z" }, null, -1)
  ])))
}
export default { render: render }